export const COMMERCIAL = 'Commercial';
export const PATRIMOINE = 'Patrimoine';

export const SECTEUR_TYPE = [
  { libelle: 'addEditSecteur.type.commercial', code: COMMERCIAL },
  { libelle: 'addEditSecteur.type.patrimoine', code: PATRIMOINE },
];
